import '@uiw/react-markdown-preview/markdown.css';
import MDEditor, { getCommands, getExtraCommands } from '@uiw/react-md-editor';
import '@uiw/react-md-editor/markdown-editor.css';
import 'property-information'; //
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import rehypeSanitize from 'rehype-sanitize';

export interface IResourceMarkdownEditorProps {
    value: string;
    onUpdate: (value: string | undefined) => void;
}

export default function ResourceMarkdownEditor({ value, onUpdate }: IResourceMarkdownEditorProps) {
    const { t } = useTranslation();

    const handleUpdate = (value: string | undefined) => {
        onUpdate(value);
    };

    const customCommands = useMemo(() => {
        return getCommands().map((cmd) => ({
            ...cmd,
            buttonProps: {
                ...cmd.buttonProps,
                'aria-label': t(`editor.${cmd.name}`), // Use translated label
                title: t(`editor.${cmd.name}`), // Ensure tooltip updates
                style: { height: '2rem', width: '2rem' }, // Ensure button size is minimum hit target 42px
            },
            icon: <span aria-hidden="true">{cmd.icon}</span>,
        }));
    }, [t]);

    const extraCommands = useMemo(() => {
        return getExtraCommands().map((cmd) => ({
            ...cmd,
            buttonProps: {
                ...cmd.buttonProps,
                'aria-label': t(`editor.${cmd.name}`), // Use translated label
                title: t(`editor.${cmd.name}`), // Ensure tooltip updates
                style: { height: '2rem', width: '2rem' },
            },
        }));
    }, [t]);

    return (
        <div>
            <MDEditor
                defaultTabEnable={false}
                height={600}
                value={value}
                commands={customCommands}
                extraCommands={extraCommands}
                onChange={handleUpdate}
                textareaProps={{
                    placeholder: t('editor.placeholder'),
                    maxLength: 12000,
                }}
                previewOptions={{
                    disallowedElements: ['style', 'script', 'language-js', 'language-css'], // shouldn't be needed with sanitize and md => md but adding for caution
                    rehypePlugins: [[rehypeSanitize]],
                }}
            />
        </div>
    );
}
